<template>
  <div v-if="!item.hidden">
    <!-- 没有子集 -->
    <template v-if="hasOneShowingChild(item, item.children) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <app-link
        v-if="onlyOneChild.meta"
        :to="resolvePath(onlyOneChild.path, onlyOneChild.query)"
      >
        <!-- v-if="onlyOneChild.meta.icon != '#'" -->
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'sub-menu-title-noDropdown': !isNest }"
        >
          <svg-icon
            class="menu-icon"
            :icon-class="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
          />
          <template #title>
            <span class="menu-title">{{ proxy.$t('menu.' + onlyOneChild.name) }}</span>
          </template>
        </el-menu-item>
      </app-link>
    </template>
    <!-- 有子集 -->
    <el-sub-menu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)"
      teleported
    >
      <template
        v-if="item.meta"
        #title
      >
        <svg-icon
          class="menu-icon"
          :icon-class="item.name === 'StoreManag' && item.meta.icon === '#' ? 'storeManag' : item.meta.icon"
        />
        <span class="menu-title">{{ proxy.$t('menu.' + item.name) }}</span>
      </template>
      <sidebar-item
        v-for="(child, index) in item.children"
        :key="child.path + index"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-sub-menu>
  </div>
</template>

<script setup lang="ts">
import { isExternal } from '@/utils/validate';
import AppLink from './Link.vue';
import { getNormalPath } from '@/utils/ruoyi';
import { RouteRecordRaw } from 'vue-router';
const { proxy } = getCurrentInstance() as ComponentInternalInstance;

const props = defineProps({
  item: {
    type: Object as PropType<RouteRecordRaw>,
    required: true,
  },
  isNest: {
    type: Boolean,
    default: false,
  },
  basePath: {
    type: String,
    default: '',
  },
});

const onlyOneChild = ref<any>({});

const hasOneShowingChild = (parent: RouteRecordRaw, children?: RouteRecordRaw[]) => {
  if (!children) {
    children = [];
  }
  const showingChildren = children.filter((item) => {
    if (item.hidden) {
      return false;
    }
    onlyOneChild.value = item;
    return true;
  });

  // When there is only one child router, the child router is displayed by default
  if (showingChildren.length === 1) {
    return true;
  }

  // Show parent if there are no child router to display
  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, path: '', noShowingChildren: true };
    return true;
  }

  return false;
};

const resolvePath = (routePath: string, routeQuery?: string): any => {
  if (isExternal(routePath)) {
    return routePath;
  }
  if (isExternal(props.basePath as string)) {
    return props.basePath;
  }
  if (routeQuery) {
    const query = JSON.parse(routeQuery);
    return { path: getNormalPath(`${props.basePath }/${ routePath}`), query };
  }
  return getNormalPath(`${props.basePath }/${ routePath}`);
};
</script>
<style>
.el-sub-menu .el-sub-menu__icon-arrow {
  right: auto;
  inset-inline-end: 10px;
}
.el-menu .el-menu--inline {
  padding: 0;
}
</style>

<style scoped>
.menu-icon {
  font-size: 20px;
}
</style>
